export const indexDateSectionMessagesEn = {
  // Index Date Section
  'projects.cohortBuilderPage.setIndexDateDialog.description':
    'Assign an index date to the cohort you are creating.',
  'projects.cohortBuilderPage.setIndexDateDialog.titleSet': 'Index date',
  'projects.cohortBuilderPage.setIndexDateDialog.titleView': 'View index date',
  'projects.cohortBuilderPage.setIndexDateDialog.cancelBtnEditable': 'Cancel',
  'projects.cohortBuilderPage.setIndexDateDialog.cancelBtnView': 'Close',
  'projects.cohortBuilderPage.setIndexDateDialog.saveBtn': 'Set index date',
  'projects.cohortBuilderPage.setIndexDateDialog.typeLabel': 'Type',
  'our.cohortBuilder.setIndexDateDialog.typePlaceholder': 'Select type',
  'projects.cohortBuilderPage.setIndexDateDialog.eventLabel': 'Event',
  'projects.cohortBuilderPage.setIndexDateDialog.eventPlaceholder': 'Select event',
  'projects.cohortBuilderPage.setIndexDateDialog.noOptionsText': 'No instance events defined',
  'projects.cohortBuilderPage.setIndexDateDialog.calendarDateLabel': 'Date',
  'projects.cohortBuilderPage.setIndexDateDialog.restrictIndexDateCheckbox':
    'Restrict index date to occur within a specific date range.',
  'projects.cohortBuilderPage.setIndexDateDialog.startDateLabel': 'Start date',
  'projects.cohortBuilderPage.setIndexDateDialog.endDateLabel': 'End date',
  'projects.cohortBuilderPage.setIndexDateDialog.calDateInvalidError':
    'Invalid format. Enter MM/DD/YYYY.',
  'projects.cohortBuilderPage.setIndexDateDialog.calDateMinDateError': 'Minimum date is {minDate}.',
  'projects.cohortBuilderPage.setIndexDateDialog.calDateMaxDateError': 'Maximum date is {maxDate}.',
  'projects.cohortBuilderPage.setIndexDateDialog.calDateFutureError': 'Maximum date is {today}.',
  'projects.cohortBuilderPage.setIndexDateDialog.calDateUnknownError':
    'Unknown date error {error}.',

  // index date view card
  'projects.cohortBuilderPage.indexDateViewCard.fieldTypeLabel': 'Type',
  'projects.cohortBuilderPage.indexDateViewCard.fieldEventLabel': 'Event',
  'projects.cohortBuilderPage.indexDateViewCard.fieldDateLabel': 'Date',
  'projects.cohortBuilderPage.indexDateViewCard.fieldDateRangeLabel': 'Date range restriction',
  'projects.cohortBuilderPage.indexDateViewCard.setIndexDateBtnLabel': 'Set index date',
  'projects.cohortBuilderPage.indexDateViewCard.emptyMainMsg': 'No index date',
  'projects.cohortBuilderPage.indexDateViewCard.emptySubMsg': 'Set an index date to get started',

  // index date delete modal
  'projects.cohortBuilderPage.indexDateDeleteModal.title': 'Delete index date',
  'projects.cohortBuilderPage.indexDateDeleteModal.submittingTitle': 'Deleting index date',
};
